(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["email-signup"] && !Shopify.designMode) return;
  try {
    // Gestion du message slide-in pour l'inscription email
  document.addEventListener('DOMContentLoaded', function() {
    // Trouver tous les messages d'inscription email
    const emailSignupMessages = document.querySelectorAll('.email-signup__message');

    emailSignupMessages.forEach(message => {
      // Ajouter la classe pour l'auto-hide après 4 secondes
      message.classList.add('email-signup__message--auto-hide');

      // Optionnel: permettre la fermeture manuelle en cliquant sur le message
      message.addEventListener('click', function() {
        message.classList.add('email-signup__message--exiting');
        setTimeout(() => {
          message.remove();
        }, 200);
      });

      // Fermer avec la touche Escape
      message.addEventListener('keydown', function(event) {
        if (event.key === 'Escape') {
          message.classList.add('email-signup__message--exiting');
          setTimeout(() => {
            message.remove();
          }, 200);
        }
      });

      // Rendre le message focusable pour l'accessibilité
      message.setAttribute('tabindex', '0');
      message.setAttribute('role', 'alert');
    });
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["redirection-hm"] && !Shopify.designMode) return;
  try {
    // Gestion des clics sur le bouton de redirection HM
  document.addEventListener('DOMContentLoaded', function() {
    const redirectionButtons = document.querySelectorAll('.redirection-hm-button');
    
    redirectionButtons.forEach(button => {
      button.addEventListener('click', function(event) {
        // Ajouter une classe de chargement
        this.classList.add('loading');
        
        // Optionnel: tracker l'événement
        if (typeof gtag !== 'undefined') {
          gtag('event', 'click', {
            event_category: 'Redirection',
            event_label: 'HM',
            value: this.href
          });
        }
        
        // Optionnel: délai pour l'animation
        setTimeout(() => {
          this.classList.remove('loading');
        }, 1000);
      });
    });
  });
  } catch(e) { console.error(e); }
})();

})();
